/** Глобальный API Яндекс.Карт 2.1, подключённый скриптом в head. */
export default window.ymaps;
